<template>
	<div class="app-main">
		<div class="app-bar">
			<div class="app-bar-title">iGolf Staff</div>
		</div>

		<div class="app-content">
			<!-- display login code form if there are users who have login codes assigned -->
			<login-code-form v-if="hasLoginCodes"/>

			<!-- if there are no users with login codes make the standard login form auto focus -->
			<login-form :autofocus="!hasLoginCodes" />
		</div>
	</div>
</template>

<script>
import LoginForm from './LoginForm.vue';
import LoginCodeForm from './LoginCodeForm.vue';

export default {
	components: { LoginForm, LoginCodeForm },

	data() {
		return { 
			hasLoginCodes: false,
		}
	},

	mounted()
	{
		this.hasLoginCodes = window._initData.hasLoginCodes;
	}
}
</script>